import { map$ } from '../stores/store-map.js';
import { monitorLoadingError } from './obsoleteApi.js';
export function planLazyLoadingMapRelatedComponents() {
    const subscription = map$.subscribe((map) => {
        if (map) {
            monitorLoadingError(import('../elements/element-layers.js'));
            monitorLoadingError(import('../elements/element-poi-popup.js'));
            monitorLoadingError(import('../elements/element-sightseeing-details.js'));
            monitorLoadingError(import('../elements/element-travelreport-details.js'));
            monitorLoadingError(import('../elements/element-place-details.js'));
            monitorLoadingError(import('../elements/element-big-gallery.js'));
            subscription.unsubscribe();
        }
    });
}
//# sourceMappingURL=mapComponentsLazyLoading.js.map